import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#73AF00"
  }} d="M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345  v-73.471H0V385.379z" /><path style={{
    fill: "#464655"
  }} d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471  C512,105.443,494.833,88.276,473.655,88.276z" /><rect y={200.09} style={{
    fill: "#C8414B"
  }} width={512} height={111.81} /><g><rect y={194.21} style={{
      fill: "#F5F5F5"
    }} width={512} height={17.655} /><rect y={300.14} style={{
      fill: "#F5F5F5"
    }} width={512} height={17.655} /><path style={{
      fill: "#F5F5F5"
    }} d="M303.268,181.618c7.108-14.657,14.525-48.61,14.525-48.61s-22.072,26.845-29.182,41.501   c-1.49,3.072-0.858,6.605,1.294,8.995l-80.967,166.934l5.496,2.666l80.967-166.934C298.613,186.381,301.779,184.69,303.268,181.618   z" /><path style={{
      fill: "#F5F5F5"
    }} d="M208.732,181.618c-7.108-14.657-14.525-48.61-14.525-48.61s22.072,26.845,29.181,41.501   c1.49,3.072,0.858,6.605-1.294,8.995l80.968,166.934l-5.496,2.666L216.598,186.17C213.387,186.381,210.221,184.69,208.732,181.618z   " /></g><path style={{
    fill: "#C8414B"
  }} d="M300.138,256c0,48.754-36.012,88.276-44.138,88.276S211.862,304.754,211.862,256  s36.012-88.276,44.138-88.276S300.138,207.246,300.138,256z" /><g><path style={{
      fill: "#464655"
    }} d="M291.31,298.591c5.199-12.631,8.828-27.14,8.828-42.591s-3.628-29.959-8.828-42.591   c-5.199,12.631-8.828,27.14-8.828,42.591S286.111,285.959,291.31,298.591z" /><path style={{
      fill: "#464655"
    }} d="M220.69,213.409c-5.199,12.631-8.828,27.14-8.828,42.591c0,15.45,3.628,29.959,8.828,42.591   c5.199-12.631,8.828-27.14,8.828-42.591S225.889,226.041,220.69,213.409z" /></g><g><ellipse style={{
      fill: "#F5F5F5"
    }} cx={256} cy={256} rx={8.828} ry={13.241} /><path style={{
      fill: "#F5F5F5"
    }} d="M257.324,167.724v75.034c2.407-5.01,6.676-19.815,6.676-37.517   C264,187.538,259.731,172.734,257.324,167.724z" /><path style={{
      fill: "#F5F5F5"
    }} d="M254.676,167.724c-2.407,5.01-6.676,19.814-6.676,37.517s4.269,32.508,6.676,37.517V167.724z" /><path style={{
      fill: "#F5F5F5"
    }} d="M257.324,269.241v75.034c2.407-5.01,6.676-19.815,6.676-37.517   C264,289.055,259.731,274.251,257.324,269.241z" /><path style={{
      fill: "#F5F5F5"
    }} d="M254.676,269.241c-2.407,5.01-6.676,19.814-6.676,37.517s4.269,32.508,6.676,37.517V269.241z" /></g><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };